/**
 * Distance attenuation (spec §10: "inverse, clamped", not positional in M1; D-035: silent beyond 20 km).
 * The Web Audio "inverse" model: full volume inside `refDistance`, then ref / (ref + rolloff × (d − ref)),
 * and a hard cut at `maxDistance`. Pure and allocation-free.
 */
import type { FalloffConfig } from './sfxSchema'

/** Gain 0..1 for a sound `distance` metres from the listener. NaN or ≥ maxDistance → 0. */
export function distanceGain(distance: number, f: FalloffConfig): number {
  if (!(distance < f.maxDistance)) return 0
  if (distance <= f.refDistance) return 1
  return f.refDistance / (f.refDistance + f.rolloff * (distance - f.refDistance))
}

/** Euclidean distance between two float64 world points (D-011: computed in float64, never in three.js). */
export function distance64(ax: number, ay: number, az: number, bx: number, by: number, bz: number): number {
  const dx = ax - bx
  const dy = ay - by
  const dz = az - bz
  return Math.sqrt(dx * dx + dy * dy + dz * dz)
}
